import React from 'react';

const AllianceMembers = () => {
  return <h1>AllianceMembers Page</h1>;
};

export default AllianceMembers;
